/* Astro PDP - gallery, variants, countdown, accordions, pincode, sticky bar */
(function () {
  'use strict';

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = value.split('.');
    var intPart = parts[0];
    var last3 = intPart.slice(-3);
    var rest = intPart.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    var out = last3 + (parts[1] ? '.' + parts[1] : '');
    return (format || 'Rs. {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */

  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-apdp-slides]');
    if (!slidesWrap) return;
    var slides = Array.prototype.slice.call(slidesWrap.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-dot]'));
    var index = 0;

    function mark(i) {
      index = i;
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      slides.forEach(function (s, n) {
        if (n !== i) {
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
    }

    function goTo(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      var target = slides[i];
      if (!target) return;
      slidesWrap.scrollTo({ left: target.offsetLeft - slidesWrap.offsetLeft, behavior: 'smooth' });
      mark(i);
    }

    root.apdpGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) {
          goTo(i);
          return;
        }
      }
    };

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        goTo(i);
      });
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        goTo(i);
      });
    });

    var prev = root.querySelector('[data-apdp-prev]');
    var next = root.querySelector('[data-apdp-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var raf;
    slidesWrap.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        var mid = slidesWrap.scrollLeft + slidesWrap.clientWidth / 2;
        for (var i = 0; i < slides.length; i++) {
          var left = slides[i].offsetLeft - slidesWrap.offsetLeft;
          if (mid >= left && mid < left + slides[i].offsetWidth) {
            if (i !== index) mark(i);
            break;
          }
        }
      });
    }, { passive: true });

    mark(0);
  }

  /* ------------------------------------------------------------------ */
  /* Variants                                                            */
  /* ------------------------------------------------------------------ */

  function initVariants(root) {
    var dataEl = root.querySelector('[data-apdp-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = root.querySelector('[data-apdp-form]') || root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('.product-variant-id');
    var addBtn = root.querySelector('[data-apdp-add]');
    var priceNow = root.querySelector('[data-apdp-price-now]');
    var priceWas = root.querySelector('[data-apdp-price-was]');
    var priceOff = root.querySelector('[data-apdp-price-off]');
    var stickyPrice = root.querySelector('[data-apdp-sticky-price]');
    var gallery = root.querySelector('[data-apdp-gallery]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-option]'));
    var format = root.dataset.moneyFormat || 'Rs. {{amount}}';
    var updateUrl = root.dataset.updateUrl === 'true';
    var productUrl = root.dataset.productUrl || '';

    function selectedOptions() {
      var out = [];
      inputs.forEach(function (input) {
        if (input.checked || input.tagName === 'SELECT') {
          var pos = parseInt(input.dataset.optionPosition, 10) - 1;
          out[pos] = input.tagName === 'SELECT' ? input.value : input.value;
        }
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== undefined && variants[i].options[j] !== opts[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function refreshAvailability(current) {
      inputs.forEach(function (input) {
        if (input.tagName === 'SELECT') return;
        var pos = parseInt(input.dataset.optionPosition, 10) - 1;
        var probe = selectedOptions();
        probe[pos] = input.value;
        var found = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== undefined && variants[i].options[j] !== probe[j]) {
              ok = false;
              break;
            }
          }
          if (ok) {
            found = variants[i];
            if (found.available) break;
          }
        }
        input.disabled = !found || !found.available;
      });
      if (current) { /* keep signature stable */ }
    }

    function render(variant) {
      if (idInput) {
        idInput.value = variant ? variant.id : '';
        idInput.disabled = !variant || !variant.available;
      }

      if (addBtn) {
        var span = addBtn.querySelector('[data-apdp-add-text]');
        if (!variant) {
          addBtn.disabled = true;
          if (span) span.textContent = addBtn.dataset.unavailableText || 'Unavailable';
        } else if (!variant.available) {
          addBtn.disabled = true;
          if (span) span.textContent = addBtn.dataset.soldOutText || 'Sold out';
        } else {
          addBtn.disabled = false;
          if (span) span.textContent = addBtn.dataset.addText || 'Add to cart';
        }
      }

      if (variant && priceNow) {
        priceNow.textContent = money(variant.price, format);
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceWas) {
          priceWas.textContent = hasCompare ? money(variant.compare_at_price, format) : '';
          priceWas.hidden = !hasCompare;
        }
        if (priceOff) {
          if (hasCompare) {
            var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            priceOff.textContent = pct + '% OFF';
            priceOff.hidden = false;
          } else {
            priceOff.hidden = true;
          }
        }
        if (stickyPrice) {
          stickyPrice.innerHTML =
            money(variant.price, format) +
            (hasCompare ? '<s>' + money(variant.compare_at_price, format) + '</s>' : '');
        }
      }

      if (variant && variant.media_id && gallery && gallery.apdpGoToMedia) {
        gallery.apdpGoToMedia(variant.media_id);
      }

      if (variant && updateUrl && productUrl && window.history && history.replaceState) {
        history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      }

      root.dispatchEvent(new CustomEvent('apdp:variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariant(selectedOptions());
        refreshAvailability(variant);
        render(variant);
        var label = root.querySelector('[data-apdp-option-current="' + input.dataset.optionPosition + '"]');
        if (label) label.textContent = input.value;
      });
    });

    if (form) refreshAvailability(findVariant(selectedOptions()));
  }

  /* ------------------------------------------------------------------ */
  /* Countdown                                                           */
  /* ------------------------------------------------------------------ */

  function initTimer(el) {
    var hours = parseInt(el.dataset.apdpTimerHours, 10) || 0;
    var template = el.dataset.apdpTimerText || 'Offer ends in {h} hr : {m} min : {s} sec';
    var key = 'apdp-timer-' + (el.dataset.apdpTimerKey || 'global');
    var deadline;

    if (hours > 0) {
      var stored = null;
      try {
        stored = window.localStorage.getItem(key);
      } catch (e) {
        stored = null;
      }
      deadline = stored ? parseInt(stored, 10) : 0;
      if (!deadline || deadline < Date.now()) {
        deadline = Date.now() + hours * 3600000;
        try {
          window.localStorage.setItem(key, String(deadline));
        } catch (e) { /* storage blocked */ }
      }
    } else {
      var midnight = new Date();
      midnight.setHours(23, 59, 59, 999);
      deadline = midnight.getTime();
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        if (hours > 0) {
          deadline = Date.now() + hours * 3600000;
          try {
            window.localStorage.setItem(key, String(deadline));
          } catch (e) { /* storage blocked */ }
          diff = deadline - Date.now();
        } else {
          el.hidden = true;
          return;
        }
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = template
        .replace('{h}', pad(h))
        .replace('{m}', pad(m))
        .replace('{s}', pad(s));
    }

    tick();
    window.setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------ */
  /* Accordions + offer toggle                                           */
  /* ------------------------------------------------------------------ */

  function initToggles(scope) {
    scope.querySelectorAll('[data-apdp-toggle]').forEach(function (btn) {
      if (btn.dataset.apdpToggleBound) return;
      btn.dataset.apdpToggleBound = 'true';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Review carousel                                                     */
  /* ------------------------------------------------------------------ */

  function initReviews(root) {
    var track = root.querySelector('[data-apdp-rev-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-rev-dot]'));
    var index = 0;

    function mark(i) {
      index = i;
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function goTo(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      if (!items[i]) return;
      track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    var prev = root.querySelector('[data-apdp-rev-prev]');
    var next = root.querySelector('[data-apdp-rev-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var autoplay = parseInt(root.dataset.apdpRevAutoplay, 10) || 0;
    if (autoplay > 0 && items.length > 1) {
      window.setInterval(function () { goTo(index + 1); }, autoplay * 1000);
    }

    mark(0);
  }

  /* ------------------------------------------------------------------ */
  /* Pincode / delivery estimate                                         */
  /* ------------------------------------------------------------------ */

  function initDelivery(root) {
    var wrap = root.querySelector('[data-apdp-delivery]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-apdp-pin-input]');
    var btn = wrap.querySelector('[data-apdp-pin-btn]');
    var out = wrap.querySelector('[data-apdp-pin-result]');
    if (!input || !btn || !out) return;

    var minDays = parseInt(wrap.dataset.minDays, 10) || 3;
    var maxDays = parseInt(wrap.dataset.maxDays, 10) || 7;
    var okText = wrap.dataset.okText || 'Estimated delivery between {from} and {to}';
    var errText = wrap.dataset.errText || 'Please enter a valid 6 digit pincode';

    function fmt(date) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return date.getDate() + ' ' + months[date.getMonth()];
    }

    function check() {
      var pin = (input.value || '').replace(/\D/g, '');
      out.hidden = false;
      if (pin.length !== 6) {
        out.textContent = errText;
        out.classList.add('apdp-deliv__result--error');
        return;
      }
      var from = new Date();
      from.setDate(from.getDate() + minDays);
      var to = new Date();
      to.setDate(to.getDate() + maxDays);
      out.classList.remove('apdp-deliv__result--error');
      out.textContent = okText.replace('{from}', fmt(from)).replace('{to}', fmt(to)).replace('{pin}', pin);
      try {
        window.localStorage.setItem('apdp-pincode', pin);
      } catch (e) { /* storage blocked */ }
    }

    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });

    try {
      var saved = window.localStorage.getItem('apdp-pincode');
      if (saved) {
        input.value = saved;
        check();
      }
    } catch (e) { /* storage blocked */ }
  }

  /* ------------------------------------------------------------------ */
  /* Sticky add to cart                                                  */
  /* ------------------------------------------------------------------ */

  function initSticky(root) {
    var bar = root.querySelector('[data-apdp-sticky]');
    var anchor = root.querySelector('[data-apdp-buy]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    ).observe(anchor);

    var proxyAdd = bar.querySelector('[data-apdp-sticky-add]');
    if (proxyAdd) {
      proxyAdd.addEventListener('click', function () {
        var real = root.querySelector('[data-apdp-add]');
        if (real && !real.disabled) real.click();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Buy now fallback (skipped when GoKwik claims the button)            */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-apdp-buy-now]') : null;
    if (!btn || btn.dataset.gokwikProcessed) return;
    var root = btn.closest('[data-apdp-root]');
    var form = root && (root.querySelector('[data-apdp-form]') || root.querySelector('form[action*="/cart/add"]'));
    if (!form) return;
    event.preventDefault();

    var body = new FormData(form);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  });

  /* ------------------------------------------------------------------ */
  /* Bundle "add both to cart"                                           */
  /* ------------------------------------------------------------------ */

  function initBundle(root) {
    var btn = root.querySelector('[data-apdp-bundle-add]');
    if (!btn) return;
    var note = root.querySelector('[data-apdp-bundle-note]');

    btn.addEventListener('click', function () {
      var picks = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-bundle-variant]'));
      var items = picks
        .map(function (el) {
          return { id: parseInt(el.value, 10), quantity: 1 };
        })
        .filter(function (i) {
          return i.id;
        });
      if (!items.length) return;

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          btn.disabled = false;
          btn.textContent = original;
          if (data && data.status) {
            if (note) note.textContent = data.description || data.message || 'Could not add to cart.';
            return;
          }
          if (note) note.textContent = '';
          var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (drawer && typeof drawer.open === 'function') {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = '/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          if (note) note.textContent = 'Could not add to cart. Please try again.';
        });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */

  function boot(scope) {
    var context = scope || document;

    context.querySelectorAll('[data-apdp-root]').forEach(function (root) {
      if (root.dataset.apdpBooted) return;
      root.dataset.apdpBooted = 'true';
      var gallery = root.querySelector('[data-apdp-gallery]');
      if (gallery) initGallery(gallery);
      initVariants(root);
      initReviews(root);
      initDelivery(root);
      initSticky(root);
    });

    context.querySelectorAll('[data-apdp-timer]').forEach(function (el) {
      if (el.dataset.apdpTimerBooted) return;
      el.dataset.apdpTimerBooted = 'true';
      initTimer(el);
    });

    context.querySelectorAll('[data-apdp-bundle]').forEach(function (el) {
      if (el.dataset.apdpBundleBooted) return;
      el.dataset.apdpBundleBooted = 'true';
      initBundle(el);
    });

    initToggles(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  window.apdpBoot = boot;
})();
